export enum LogLevel {
  'TRACE',
  'DEBUG',
  'INFO',
  'WARN',
  'ERROR',
  'FATAL',
}

export const isLogLevel = (level: any): level is  keyof typeof LogLevel => {
    return typeof level === 'string' && [ 'TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'FATAL'].includes( level )
}



export type LambdaLogLevel = 'TRACE' | 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'FATAL'
export interface ILambdaLogger {
  logAtLevel: LogLevel
  trace: (...msg: any[]) => StdLogOutput<'TRACE'>
  debug: (...msg: any[]) => StdLogOutput<'DEBUG'>
  info: (...msg: any[]) => StdLogOutput<'INFO'>
  warn: (...msg: any[]) => StdLogOutput<'WARN'>
  error: (...msg: any[]) => StdLogOutput<'ERROR'>
  fatal: (...msg: any[]) => StdLogOutput<'FATAL'>
  flush: () => any
}

export type StdLogInput = string

export type StdLogOutput<Level extends LambdaLogLevel> = {
  timestamp: number
  functionName: string
  level: Level
  message: any[]
}

export type LambdaInvocationLogs = {
  timestamp: number
  functionName: string
  maxLevel: LambdaLogLevel
  logs: StdLogOutput<LambdaLogLevel>[]
}
